import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faPaperclip, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { Modal } from "@/components/modal";
import { Button } from "@/components/button";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { useLetterPreview } from "./use-letter-preview";
/** Previews a selected letter and lets the user confirm attaching it. */
export function LetterPreviewModal(_ref) {
  var opened = _ref.opened,
    letterId = _ref.letterId,
    letterTitle = _ref.letterTitle,
    patientId = _ref.patientId,
    workspaceId = _ref.workspaceId,
    isAttaching = _ref.isAttaching,
    onClose = _ref.onClose,
    onAttach = _ref.onAttach;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var preview = useLetterPreview(patientId, letterId, workspaceId);
  if (!opened) return null;
  var footer = /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-3"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    leftIcon: faArrowLeft,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LETTER_PREVIEW_BACK, {
        patientId: patientId
      });
      onClose();
    },
    "data-testid": "letter-preview-back"
  }, t("back", {
    defaultValue: "Back"
  })), /*#__PURE__*/React.createElement(Button, {
    leftIcon: faPaperclip,
    loading: isAttaching,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LETTER_PREVIEW_ATTACH, {
        patientId: patientId
      });
      onAttach();
    },
    "data-testid": "letter-preview-attach"
  }, t("attach_this_letter", {
    defaultValue: "Attach this letter"
  })));
  return /*#__PURE__*/React.createElement(Modal, {
    opened: true,
    onClose: onClose,
    size: "xl",
    title: letterTitle,
    subtitle: preview.name || undefined,
    closeTestId: "letter-preview-close",
    footer: footer
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-[60vh] overflow-auto scrollbar-sds rounded-sds-200 border border-sds-base-default"
  }, preview.isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "flex h-full items-center justify-center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    spin: true,
    className: "h-5 w-5 text-sds-brand-default"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-white p-4 text-black [&_img]:h-auto [&_img]:max-w-full",
    dangerouslySetInnerHTML: {
      __html: preview.html
    }
  })));
}